import React from "react";
import { Box, Typography, IconButton, Collapse, Divider } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import FilterBar from "../../../../components/FilterNSearchBar/FilterNSearchBar";

const EvidenceTableContainer = ({
  title = "Evidence",
  searchTerm,
  onSearchChange,
  clearFilters,
  filteredCount,
  countLabel,
  tableExpanded = true,
  onToggleExpand,
  children,
  filters = [],
  selectedFilter = null,
  onFilterChange = () => {},
  showExpandCollapse = false,
  expandText = "Check daily activity here",
  rightAction = null,
  leftAction = null,
  customAction = null,
  selectedCount,
  selectedLabel,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          borderRadius: "12px",
          border: `1px solid ${theme.customColors.border.main}`,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          backgroundColor: theme.customColors.background.main,
          boxShadow: theme.customColors.shadow.main,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 1.5,
            borderBottom: tableExpanded ? `1px solid ${theme.customColors.border.main}` : "none",
            backgroundColor: theme.customColors.background.cardHeader,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                color: theme.customColors.text.strong,
              }}
            >
              {title}
            </Typography>
            {leftAction && (
              <Box onClick={(e) => e.stopPropagation()}>
                {leftAction}
              </Box>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {rightAction && (
              <Box onClick={(e) => e.stopPropagation()}>
                {rightAction}
              </Box>
            )}
            {showExpandCollapse && (
              <Typography
                variant="body2"
                sx={{
                  fontSize: "0.875rem",
                  color: theme.customColors.text.secondary,
                  fontWeight: 500,
                }}
              >
                {expandText}
              </Typography>
            )}
            {showExpandCollapse && (
              <IconButton
                size="small"
                onClick={onToggleExpand}
                sx={{
                  color: theme.palette.text.primary,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "transparent"
                  }
                }}
              >
                <ArrowForwardIos sx={{ fontSize: 16 }} />
              </IconButton>
            )}
          </Box>
        </Box>

        {/* Collapsible Content */}
        <Collapse in={tableExpanded}>
          {/* Search and Filter Bar */}
          <Box
            sx={{
              p: 2,
              pb: 1.5,
              backgroundColor: theme.customColors.background.main,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box sx={{ flex: 1 }}>
                <FilterBar
                  searchQuery={searchTerm}
                  onSearchChange={onSearchChange}
                  filterLabel=""
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterChange={onFilterChange}
                  onClearFilters={clearFilters}
                  countLabel={countLabel || `${filteredCount} ${filteredCount === 1 ? 'item' : 'items'} found`}
                />
              </Box>
              {customAction && (
                <Box sx={{ ml: 2, display: "flex", alignItems: "center", height: "40px", mt: "0px" }}>
                  {customAction}
                </Box>
              )}
            </Box>
          </Box>

          <Divider sx={{ borderColor: theme.customColors.border.main }} />

          {/* Table Content */}
          <Box>
            {children}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default EvidenceTableContainer;
